import { css } from 'linaria';

export const bannersSectionStyles = css`
  width: 100%;
  margin-bottom: 80px;

  @media (--only-tablet) {
    margin-bottom: 64px;
  }

  @media (--only-mobile) {
    margin-bottom: 56px;
  }
`;

export const bannerSlide = css`
  && {
    position: relative;
    width: 580px;
    height: 264px;
    margin-right: 18px;

    @media (--to-desktop) {
      width: 461px;
      height: 210px;
      margin-right: 25px;

      & a {
        height: 100%;
      }
    }

    @media (--only-mobile) {
      width: 263px;
      height: auto;
    }

    &:hover {
      button {
        color: var(--button-hover-color);
        background-color: var(--button-hover-bg);
      }
    }
  }
`;

export const bannerSingleSlide = css`
  && {
    width: 100%;
    margin-right: 0;

    & img {
      @media (--only-tablet) {
        object-position: -110px 0;
      }

      @media (--only-mobile) {
        object-position: -22vw;
      }
    }
  }
`;

export const bannerCard = css`
  box-shadow: unset;
`;

export const bannerImage = css`
  width: 100%;
  height: 100%;
  border-radius: var(--rounding-m);

  @media (--only-mobile) {
    height: 160px;
    border-radius: var(--rounding-m) var(--rounding-m) 0 0;
  }
`;

export const bannerBody = css`
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 304px;
  height: 216px;
  padding: 24px;
  background-color: var(--background-primary);
  border-radius: var(--rounding-m);

  @media (--to-desktop) {
    top: 19px;
    right: 19px;
    width: 247px;
    height: 172px;
    padding: 19px;
  }

  @media (--only-mobile) {
    position: relative;
    top: 0;
    right: 0;
    width: 100%;
    padding: 16px;
    background-color: var(--background-secondary);
  }
`;

export const bannerSingleBody = css`
  && {
    width: 412px;

    @media (--to-desktop) {
      width: 292px;
    }

    @media (--only-mobile) {
      width: 100%;
    }
  }
`;

export const bannerTitle = css`
  margin-bottom: 12px;

  @media (--to-desktop) {
    margin-bottom: 8px;
    font-size: 20px;
    line-height: 26px;
  }
`;

export const bannerDescription = css`
  @media (--to-desktop) {
    font-size: 14px;
    line-height: 18px;
  }
`;

export const bannerButton = css`
  @media (--only-desktop) {
    height: 40px;
    padding: 8px 24px;
    font-size: 16px;
    line-height: 24px;
  }

  @media (--only-mobile) {
    background-color: var(--background-secondary);
    border: 2px solid #ced0d6;
  }
`;
